import HttpRequest from './core/http_request';

class MasterProvider extends HttpRequest {
  getWaterSource () {
    return this.request('get', '/masterdata/watersource');
  }

  getProvinceList () {
    return this.request('get', '/masterdata/province');
  }

  getAumphurInProvince (data) {
    return this.request('get', '/masterdata/province/' + data._id + '/amphur');
  }

  getDistrictInAmphur (data) {
    return this.request('get', '/masterdata/amphur/' + data._id + '/district');
  }
}

export default MasterProvider;
